import { render, staticRenderFns } from "./RadioCheckboxCollection.vue?vue&type=template&id=057729c4&scoped=true&"
import script from "./RadioCheckboxCollection.vue?vue&type=script&lang=js&"
export * from "./RadioCheckboxCollection.vue?vue&type=script&lang=js&"
import style0 from "./RadioCheckboxCollection.vue?vue&type=style&index=0&id=057729c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057729c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('057729c4')) {
      api.createRecord('057729c4', component.options)
    } else {
      api.reload('057729c4', component.options)
    }
    module.hot.accept("./RadioCheckboxCollection.vue?vue&type=template&id=057729c4&scoped=true&", function () {
      api.rerender('057729c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/RadioCheckboxCollection.vue"
export default component.exports